import React from 'react'
import Collection from '../common/collection'

function CollectionQ({ props }) {
  return (
    <Collection
      alt="Campanario"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/16.+campanario20.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/16.+campanario52.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/16.+campanario51.jpg',
      ]}
    />
  )
}


export default CollectionQ
